import { css } from "styled-components";

const getDarkModeColors = (lightModeColor, darkModeColor) => {
  return css`
    ${(props) => (props.theme.darkMode ? darkModeColor : lightModeColor)}
  `;
};

export default getDarkModeColors;
